import { Routes, Route } from "react-router-dom";
import { useAuth } from "./auth/useAuth";
import Login from "./pages/Login";
import Chat from "./pages/Chat";
import Stt from "./pages/Stt";
import MailLink from "./pages/MailLink";
import Tasks from "./pages/Tasks";
import SharedView from "./pages/SharedView";
import { Loader2 } from "lucide-react";

function Gate({ page = "chat" }: { page?: "chat" | "stt" | "mail" | "tasks" }) {
  const { loading, authenticated } = useAuth();
  if (loading) {
    return (
      <div className="flex h-full items-center justify-center text-muted-foreground">
        <Loader2 className="mr-2 h-5 w-5 animate-spin" /> 불러오는 중…
      </div>
    );
  }
  if (!authenticated) return <Login />;
  if (page === "stt") return <Stt />;
  if (page === "mail") return <MailLink />;
  if (page === "tasks") return <Tasks />;
  return <Chat />;
}

export default function App() {
  return (
    <Routes>
      {/* 공개 읽기전용 공유 — 로그인 불필요 */}
      <Route path="/s/:token" element={<SharedView />} />
      {/* 받아쓰기(다글로 STT) — 음성 파일 → 텍스트 변환 */}
      <Route path="/stt" element={<Gate page="stt" />} />
      {/* 개인 메일 연동 — 본인 회사 메일을 나만 검색하도록 저장 신청 */}
      <Route path="/mail" element={<Gate page="mail" />} />
      {/* 메일 업무비서 — 내 메일에서 추출한 할 일·기한 대시보드 (본인 전용) */}
      <Route path="/tasks" element={<Gate page="tasks" />} />
      <Route path="*" element={<Gate page="chat" />} />
    </Routes>
  );
}
